import { render } from "./Step_vestibular_treatmentView.vue?vue&type=template&id=6556ebe6"
import script from "./Step_vestibular_treatmentView.vue?vue&type=script&lang=js"
export * from "./Step_vestibular_treatmentView.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__